import { NavLink, Outlet, Navigate, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingCart, Users, LogOut, Eye, Image, BookOpen } from "lucide-react";
import { useAdminAuth } from "@/contexts/AdminAuthContext";

const LINKS = [
  { to: "/atelier-admin/dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "admin-nav-dashboard" },
  { to: "/atelier-admin/products", label: "Products", icon: Package, testid: "admin-nav-products" },
  { to: "/atelier-admin/orders", label: "Orders", icon: ShoppingCart, testid: "admin-nav-orders" },
  { to: "/atelier-admin/customers", label: "Customers", icon: Users, testid: "admin-nav-customers" },
  { to: "/atelier-admin/lookbook", label: "Lookbook", icon: Image, testid: "admin-nav-lookbook" },
  { to: "/atelier-admin/journal", label: "Journal", icon: BookOpen, testid: "admin-nav-journal" },
];

export default function AdminLayout() {
  const { admin, loading, logout } = useAdminAuth();
  const navigate = useNavigate();

  if (loading) return <div className="min-h-screen bg-midnight" />;
  if (!admin) return <Navigate to="/atelier-admin" replace />;

  return (
    <div className="min-h-screen bg-midnight-deep text-white flex" data-testid="admin-layout">
      <aside className="hidden md:flex w-64 bg-midnight border-r border-white/8 flex-col">
        <div className="p-6 border-b border-white/8">
          <div className="font-serif text-white text-xl tracking-[0.18em]">ASYMMETRY</div>
          <div className="text-[10px] tracking-[0.4em] uppercase text-silver/70 mt-1">Atelier · Admin</div>
        </div>
        <nav className="flex-1 p-3">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 text-[11px] tracking-[0.28em] uppercase rounded-none transition-colors ${
                  isActive ? "bg-white text-black" : "text-white/70 hover:bg-white/5 hover:text-white"
                }`
              }
            >
              <l.icon size={15} strokeWidth={1.3} />
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/8 space-y-2">
          <a
            href="/"
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-3 px-4 py-2.5 text-[11px] tracking-[0.28em] uppercase text-white/60 hover:text-white"
          >
            <Eye size={14} strokeWidth={1.3} />
            View site
          </a>
          <button
            onClick={async () => { await logout(); navigate("/atelier-admin"); }}
            data-testid="admin-logout"
            className="w-full text-left flex items-center gap-3 px-4 py-2.5 text-[11px] tracking-[0.28em] uppercase text-white/60 hover:text-white"
          >
            <LogOut size={14} strokeWidth={1.3} />
            Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-y-auto">
        <div className="p-6 md:p-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
